<template>
  <div class="MediaDetail">
    <div class="top-nav-bar">
      <van-navBar :title="pageTitle || '预览'" @click-left="$router.back()">
        <i class="icon back-arrow" slot="left"></i>
      </van-navBar>
    </div>
    <!-- 按钮菜单 -->
    <div class="btn" v-show="btnShow" @click="handleBtn"></div>
    <!-- 列表弹出层 -->
    <van-popup class="popup"
      v-model="popupShow"
      :position="popupProp.position"
      @close="popupClose"
      :style="{width:popupProp.width,height:popupProp.height}"
    >
      <div class="header">目录</div>
      <div class="list">
        <div
          class="row"
          v-for="(row,i) in detailList"
          :key="i"
          @click="handleRow(row,i)"
          :class="{'active':currentIndex === i}"
        >
          <div class="icon" :class="fileIcon[row.fileType]"/>
          <div class="value">{{ row.name }}</div>
        </div>
      </div>
    </van-popup>
    <!-- 音频 -->
    <audio class="audio" controlsList="nodownload" controls :src="detail.path" v-if="detail.fileType === 2"></audio>
    <!-- 视频 -->
    <div id="video" v-if="detail.fileType === 3"></div>
    <!--文件预览-->
    <iframe class="word" v-if="detail.fileType === 4 || detail.fileType === 5 || detail.fileType === 6 || detail.fileType === 7 || detail.fileType === 8"
    :src="`${iframeUrl}&furl=${detail.path || ''}`" :key="detail.id" />
    <!-- 图片 -->
    <van-image class="vanImg" v-if="detail.fileType === 10" fit="contain" :src="detail.path" @click="lookImage(detail.path)"></van-image>
    <!--富文本-->
    <div class="rich rich-text" v-if="detail.fileType === 0" v-html="detail.content"></div>
  </div>
</template>

<script>
import { NavBar, ImagePreview, Dialog } from 'vant';
export default {
  name: 'StudyMediaDetail',
  components: {
    'van-navBar': NavBar,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Dialog.Component.name]: Dialog.Component
  },
  data () {
    return {
      pageTitle: '', // 标题
      id: '',
      btnShow: true,
      popupShow: false,
      detail: {
        path: '',
        fileType: 0
      },
      currentIndex: 0,
      detailList: [],
      iframeUrl: '',
      popupProp: {
        position: 'bottom',
        width: '100%',
        heigth: '60%'
      },

      fileIcon: {
        0: 'icon-11', // 文件
        1: 'icon-13', // pdf
        2: 'icon-17', // MP3
        3: 'icon-14', // 视频
        4: 'icon-18', // 压缩包
        5: 'icon-13', // pdf
        6: 'icon-15', // ppt
        7: 'icon-16', // word
        8: 'icon-19', // execl
        9: 'icon-20', // 其他
        10: 'icon-12' // 文件
      }
    };
  },
  mounted () {
    const { $route: { query } } = this;
    this.getIframe();
    this.pageTitle = query.title || '预览';
    console.log(this.pageTitle);
    this.id = query.id;
    this.getDetail();
    window.addEventListener('resize', this.resize, false);
  },
  methods: {

    /*  */
    getIframe () {
      this.$http.get('file/view').then((res) => {
        this.iframeUrl = res.data.url;
      });
    },

    /* 研究媒体详情 */
    getDetail () {
      const { id, detail } = this;
      this.$http.get('courseTeach/media/detail', {
        params: {
          id
        },
        showLoading: true
      }).then((res) => {
        const { annexes } = res.data || {};
        detail.path = annexes[0].path;
        detail.fileType = annexes[0].fileType;
        this.detailList = annexes;

        this.$wxShare({
          // url: window.href, // 网址，默认使用 window.location.href
          title: '媒体融合', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
          desc: this.pageTitle, // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
          imgUrl: res.data.media.coverImage // 图片, 默认取网页中第一个img标签
        });
        // 视频
        if (detail.fileType === 3) {
          this.$nextTick(() => {
            this.videoInit(detail);
          });
        }
      });
    },

    handleRow (data, index) {
      let { detail } = this;
      detail = data || {};

      this.detail = detail;

      // 视频
      if (data.fileType === 3) {
        this.$nextTick(() => {
          this.videoInit(data);
        });
      }
      this.currentIndex = index;

      this.popupClose();
    },

    /* 视频播放 */
    videoInit (data) {
      // 定义一个变量：videoObject，用来做为视频初始化配置
      const videoObject = {
        container: '#video', // “#”代表容器的ID，“.”或“”代表容器的class
        variable: 'player', // 播放函数名称，该属性必需设置，值等于下面的new ckplayer()的对象
        video: data.path, // 视频地址
        mobileAutoFull: false, // 移动端是否默认全屏播放
        loaded: 'window.loaderHandler'
      };
      // eslint-disable-next-line new-cap
      const player = new ckplayer(videoObject);// 初始化播放器
      console.log(player);
    },

    /* 图片预览 */
    lookImage (path) {
      ImagePreview([
        path
      ]);
    },

    /* 打开弹层 */
    handleBtn () {
      this.btnShow = false;
      this.popupShow = true;
    },

    /* 关闭弹层 */
    popupClose () {
      this.popupShow = false;
      this.btnShow = true;
    },

    /* 判断手机处于横屏还是竖屏 */
    resize () {
      const { popupProp } = this;
      let width = document.documentElement.clientWidth;
      let heigth = document.documentElement.clientHeight;

      // 横屏
      if (width > heigth) {
        popupProp.position = 'left';
        popupProp.width = '60%';
        popupProp.heigth = '100vh';
      } else {
        popupProp.position = 'bottom';
        popupProp.width = '100%';
        popupProp.heigth = '60%';
      }
    }
  },
  beforeDestroyed () {
    window.addEventListener('resize', this.resize, false);
  }
};
</script>

<style lang="less" scoped>
.MediaDetail {
  position: relative;
  height: calc(100vh - 94px);
  .top-nav-bar {
    flex-shrink: 0;
    width: 100%;
    height: 94px;

    /deep/.van-nav-bar {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: 999;
      width: 100%;
      height: 94px;
      margin: auto;
      background-color: #fff;

      &::after {
        border: none;
      }

      .van-nav-bar__title {
        font-size: 34px;
        font-weight: bold;
        line-height: 94px;
        color: #222;
        color: #1a1a1a;
      }

      .van-nav-bar__left {
        left: 0;
      }

      .van-nav-bar__right {
        right: 0;
      }

      .van-nav-bar__left,
      .van-nav-bar__right {
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 94px;
        padding: 0 30px;
      }

      .back-arrow {
        width: 32px;
        height: 32px;
        background-image: url("~@/assets/images/icon_backArrow_01.png");
        background-size: contain;
      }
      .btn {
        width: 96px;
        height: 56px;
        background: linear-gradient(93deg, #2E86FF 0%, #5FA9FF 100%);
        border-radius: 8px;
        font-size: 24px;
        font-weight: 500;
        line-height: 46px;
        color: #fff;
      }
    }
  }
  .audio {
    width: 100%;
  }
  #video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 600px;
  }
  .word {
    width: 100vw;
    height: 100%;
  }
  .rich {
    padding: 30px;
    width: 100%;
    background-color: #fff !important;
    font-size: 24px;
  }
  .vanImg {
    width: 100%;
  }
  .btn {
    position: fixed;
    width: 60px;
    height: 60px;
    right: 28px;
    bottom: 40px;
    background: url('~@/assets/images/study/icon_menu_01.png') no-repeat center center/cover;
    z-index: 10;
  }
  .popup {
    width: 100vw;
    height: 686px;
    background: rgba(0,0,0,.9);
    border-radius: 16px 16px 0px 0px;
    display: flex;
    flex-direction: column;
    .header {
      height: 128px;
      font-size: 36px;
      color: #fff;
      padding: 40px;
    }
    .list {
      flex: 1;
      height: 0;
      overflow: auto;
      padding: 0 40px;
      .row {
        padding: 15px 0;
        display: flex;
        align-items: center;
        .icon {
          width: 40px;
          height: 40px;
          .loop-icon(11,'fileIcon/icon_file',20);
        }
        .value {
          margin-left: 16px;
          font-size: 28px;
          font-weight: 500;
          color: #fff;
        }
        &.active {
          .value {
            color: #5FA9FF !important;
          }
          .icon {
            width: 40px;
            height: 40px;
            .loop-icon(11,'fileIcon/icon_file',20);
          }
        }
        .tag {
          margin-left: 16px;
          width: 60px;
          height: 34px;
          border: 1px solid #FFFFFF;
          border-radius: 4px;
          font-size: 24px;
          font-weight: 500;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .tagActive {
        color: #5FA9FF !important;
        border: 2px solid #5FA9FF !important;
        font-size: 20px;
        margin-left: 12px;
        border-radius: 20px;
        padding: 4px 18px;
      }
    }
  }
}
</style>